<template>
  <div class="container text-center my-4">
    <h2>Ingresa el Código OTP</h2>
    <input v-model="otp" type="text" class="form-control my-3" placeholder="OTP" />
    <button class="btn btn-primary" @click="validateOtp">Validar OTP</button>
    <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      otp: '',
      errorMessage: '',
      correctOtp: '563478',
    };
  },
  methods: {
    validateOtp() {
      if (this.otp === this.correctOtp) {
        if (this.$route.query.email === 'postlogin@test.dev') {
          this.$router.push('/age-terms');
        } else if (this.$route.query.email === 'mipoc@test.dev') {
          this.$router.push('/welcome-back');
        }else {
          this.$router.push({ path: '/register', query: { email: this.$route.query.email } });
        }
      } else {
        this.errorMessage = 'Código incorrecto';
      }
    },
  },
};
</script>
